import classNames from "classnames";
import { DComponent } from "../../../../../../components/DComponent";
import { Tag } from "../../../../../../models/PriceTag";

export default class LowestTag extends DComponent {
  constructor({
    parent,
    id,
    tags = [],
    position = "bottom"
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("LowestTag", position),
    }, true);
    this.tags = tags;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "LowestTag");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.setPriceTags(this.tags);
  }

  /**
   * @param {[Tag]} tags 
   * @returns 
   */
  setPriceTags(tags = []) {
    if (!tags.length) return;
    let curTag;
    for (let index = 0; index < tags.length; index++) {
      const tag = tags[index];
      if (tag.tag === Tag.TAG_TYPE.LOWEST) {
        curTag = tag;
      }
    }

    $(".tag-value", this.element).attr("data-i18n", curTag && curTag.period ? "checkout_lowestPrice" : "checkout_lowestPriceAllTime");
    $(".tag-value", this.element).text(curTag && curTag.period ? $.i18n("checkout_lowestPrice") : $.i18n("checkout_lowestPriceAllTime"));
    $(".tooltip-lowest span", this.element).text(curTag ? curTag.getLabel() : "");
  }
}